import { render, staticRenderFns } from "./Events_Batchgroups.vue?vue&type=template&id=13108fe1&scoped=true&"
import script from "./Events_Batchgroups.vue?vue&type=script&lang=js&"
export * from "./Events_Batchgroups.vue?vue&type=script&lang=js&"
import style0 from "./Events_Batchgroups.vue?vue&type=style&index=0&id=13108fe1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13108fe1",
  null
  
)

export default component.exports